import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import { jsx } from 'react/jsx-runtime';

// src/factory/createMfeStore.ts
function isProductionBuild() {
  return typeof process !== "undefined" && typeof process.env !== "undefined" && process.env.NODE_ENV === "production";
}
function createMfeStore(config) {
  const { reducers, devTools = !isProductionBuild(), preloadedState } = config;
  const apis = config.apis ?? [];
  const reducerMap = { ...reducers };
  for (const api of apis) {
    reducerMap[api.reducerPath] = api.reducer;
  }
  const store = configureStore({
    reducer: reducerMap,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(...apis.map((api) => api.middleware)),
    devTools,
    preloadedState
  });
  return store;
}
function StoreProvider({
  store,
  children
}) {
  return /* @__PURE__ */ jsx(Provider, { store, children });
}

export { StoreProvider, createMfeStore };
//# sourceMappingURL=chunk-SEDIOAWQ.js.map
//# sourceMappingURL=chunk-SEDIOAWQ.js.map